export const fontFamily1 = [
  "neue-haas-grotesk-text",
  "neue-haas-grotesk-display",
  "helvetica",
  "arial",
  "-apple-system",
  "blinkmacsystemfont",
  "sans-serif",
  "apple color emoji",
  "segoe ui emoji",
  "segoe ui symbol",
].join(",");

export const fontFamily2 = [
  "arial",
  "helvetica",
  "neue-haas-grotesk-text",
  "neue-haas-grotesk-display",
  "-apple-system",
  "blinkmacsystemfont",
  "sans-serif",
  "apple color emoji",
  "segoe ui emoji",
  "segoe ui symbol",
].join(",");

export const fontFamily3 = [
  "neue-haas-grotesk-display",
  "neue-haas-grotesk-text",
  "helvetica",
  "arial",
  "-apple-system",
  "blinkmacsystemfont",
  "sans-serif",
  "apple color emoji",
  "segoe ui emoji",
  "segoe ui symbol",
].join(",");

export const typography = {
  fontFamily: fontFamily1,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  fontSize: 16,
  h1: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 700,
    fontSize: `${62 / 22}rem`,
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "-0.015em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  h2: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 600,
    fontSize: `${35 / 22}rem`,
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.375em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  h3: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 600,
    fontSize: `${36 / 22}rem`,
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  h4: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  h5: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  h6: {
    color: "white",
    fontFamily: fontFamily3,
    fontWeight: 600,
    fontSize: `${20 / 22}rem`,
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  subtitle1: {
    fontFamily: fontFamily3,
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  subtitle2: {
    fontFamily: fontFamily3,
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: 1.1,
    paddingBlock: "0.2em",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    overflowWrap: "break-word",
  },
  body1: {
    fontFamily: fontFamily1,
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: 1.5,
    letterSpacing: "0.01em",
    textTransform: "none",
  },
  body2: {
    fontFamily: fontFamily1,
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "1rem",
    lineHeight: 1.5,
    letterSpacing: "0.01em",
    textTransform: "none",
  },
  button: {
    fontFamily: fontFamily3,
    fontWeight: 500,
    lineHeight: 1.1,
    letterSpacing: "0.1em",
    textTransform: "none",
  },
  caption: {
    fontFamily: fontFamily1,
  },
  overline: {
    fontFamily: fontFamily1,
  },
  title: {
    fontFamily: fontFamily2,
    fontSize: "1.25rem",
    fontWeight: 400,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    lineHeight: 1.1,
  },
  bigNumber: {
    fontFamily: fontFamily3,
    fontSize: "2.18rem",
    fontWeight: 700,
    letterSpacing: "0.01em",
  },
};
